module.exports = __webpack_public_path__ + "img/right.624fb5c7.svg";